var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.url
        ? _c(
            "span",
            {
              staticClass: "right-content__action",
              on: { click: _vm.showModal }
            },
            [
              _c("icon-font", { attrs: { type: "gb-icon-youjian_icon" } }),
              _c("span", { staticStyle: { padding: "0 8px 0 4px" } }, [
                _vm._v(_vm._s(_vm.$t("layouts.EmailMarketing")))
              ]),
              _c("icon-font", {
                staticClass: "icon_new",
                attrs: { type: "gb-icon-new_icon", hidden: _vm.ishidden }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "a-modal",
        {
          staticStyle: { padding: "0" },
          attrs: {
            centered: "",
            footer: null,
            maskClosable: false,
            width: 420
          },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _c("div", { staticClass: "base_box" }, [
            _c("div", { staticClass: "top_box" }, [
              _c("img", {
                staticStyle: { margin: "-10px 0 -22px -14px" },
                attrs: { src: require("../../assets/title.png") }
              })
            ]),
            _c("div", { staticClass: "content_box" }, [
              _c("img", {
                attrs: { src: require("../../assets/element.png") }
              }),
              _c("div", { staticClass: "content_right" }, [
                _c("div", { staticClass: "content_right_top" }, [
                  _c("span", [_vm._v("本服务适合拥有ebay或独立站的卖家")])
                ]),
                _c("div", { staticClass: "content_right_bottom" }, [
                  _c("span", [
                    _vm._v(
                      "可打通多平台数据进行用户分群，通过邮件方式对私域流量进行精准营销，ROI最高可达"
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#FD8E00", "font-weight": "800" }
                      },
                      [_vm._v("420%")]
                    )
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "bottom_box" }, [
              _c("img", {
                staticStyle: {
                  position: "absolute",
                  right: "17px",
                  bottom: "50px"
                },
                attrs: { src: require("../../assets/tips.png") }
              }),
              _c(
                "a",
                {
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.toBytesku }
                },
                [
                  _c("img", {
                    staticStyle: { "margin-left": "8px" },
                    attrs: { src: require("../../assets/btn.png") }
                  })
                ]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }